// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // استيراد المكون الرئيسي App
import './icons'; 
// إذا لم تكن قد أضفت Font Awesome في App.js، يمكنك إضافته هنا.
// تأكد من أن هذا الجزء يتم تنفيذه مرة واحدة فقط في التطبيق.
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faPlay, faPause, faVolumeMute, faVolumeUp, faSearch, faBars, faTimes, faTv } from '@fortawesome/free-solid-svg-icons';
// library.add(faPlay, faPause, faVolumeMute, faVolumeUp, faSearch, faBars, faTimes, faTv);

<meta name="viewport" content="width=device-width, initial-scale=1.0" />

// نقطة الدخول الرئيسية لتطبيق React
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);